import React from "react";

import InfoBox from "common-ui-components/components/info-box/InfoBox";
import DonutChart from "common-ui-components/components/donut-chart/DonutChart";

const compliance = [
  {
    id: "Compliance",
    label: "Compliance",
    value: 160,
    color: "#B0D062",
  },
  {
    id: "Non Compliance",
    label: "Non Compliance",
    value: 120,
    color: "#3174A0",
  },
  {
    id: "Not Evaluated",
    label: "Not Evaluated",
    value: 120,
    color: "#49A397",
  },
];

const DeviceCompliance = ({
  complianceData,
  title,
  onFilterSelect,
  chartSize = "12rem",
  legendPadding = "0.4rem 2rem 0.4rem 0.4rem",
  chartGap,
  className,
}) => {
  let total = 0;

  const newCompliance = compliance.map((item) => {
    const value = complianceData?.[item.id] || 0;
    total += value;
    return { ...item, value };
  });

  return (
    <InfoBox
      header={title || "Device Compliance"}
      headerProps={{
        style: {
          color: "#111111",
        },
      }}
      className={className}
      childrenProps={{
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 0,
        },
      }}
    >
      <DonutChart
        data={newCompliance}
        legend
        centerText={`${total} Devices`}
        size={chartSize}
        gap={chartGap}
        legendPadding={legendPadding}
        onDatumClick={onFilterSelect}
      />
    </InfoBox>
  );
};

export default DeviceCompliance;
